import api from './api';

const ENDPOINT = 'products';

const ProductService = {
  get: (params = null) => api.get(ENDPOINT, { params }),
  getId: (id) => api.get(`${ENDPOINT}/${id}`),
  save: (data) => api.post(`${ENDPOINT}`, data),
  update: (id, data) => api.put(`${ENDPOINT}/${id}`, data),
  delete: (id) => api.delete(`${ENDPOINT}/${id}`),
  search: (params) => api.get(`${ENDPOINT}/search`, { params }),
  getFamilies: () => api.get(`${ENDPOINT}/families`),
};

export default ProductService;
